import {
  Component,
  OnInit,
} from '@angular/core';
import {
  MetaTagsService,
  RouterService,
  UserService,
  utilsFactory,
} from '@lib/gc-common';
import { environment } from '@libs/gc-common/environments/environment';

@Component({
  selector: 'mip-profile-redirect-event',
  templateUrl: './profile-redirect-event.component.html',
  styleUrls: ['./profile-redirect-event.component.scss'],
})
export class ProfileRedirectEventComponent implements OnInit {
  assetsPath = environment.assetsPath;

  constructor(
    private routerService: RouterService,
    private metatag: MetaTagsService,
    private userService: UserService,
  ) {}

  async ngOnInit() {
    const userId = await this.routerService.getRouteParam('userId');
    const profile = await this.userService.getUser(userId);

    await this.metatag.setMetaTags({
      title: 'GotChosen Experience',
      image: `${this.assetsPath}/images/event/experience/event-cover.jpg`,
      description: `${
        profile.getName() || profile.username
      } está convidando você para participar do evento online de lançamento da GotChosen`,
    });

    if (utilsFactory.isBrowser) {
      this.routerService.navigateTo('/experience');
    }
  }
}
